<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoProgramasInversion" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :programaInversion="item"></opciones>
      </template>
      <template v-slot:[`item.normatividad`]="{ item }">
        {{ item.normatividad === 1 ? 'Federal' : 'Estatal'}}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoProgramasInversionDesktop',
  props: {
    listadoProgramasInversion: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Ejercicio',
          align: 'start',
          value: 'ejercicio',
        },
        { text: 'Clave', value: 'clave' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Normatividad', value: 'normatividad' },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
